<template>
	<div id="router-body">
		<div id="main-contents">
			<h3>ようこそ。</h3>
			<p>ここはNandeのホームページPhantom Horizonです。</p>
			<p>現在はブラウザ音楽ゲーム「Dancing★Onigiri」の自作譜面がメインコンテンツです。</p>
			<h3>
				<router-link to="/danoni">Dancing★Onigiri 作品一覧</router-link>
			</h3>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
	#main-contents {
		padding: 16px;
		margin-top: 8px;
	}

</style>